import { render } from "./examination-place.vue?vue&type=template&id=e0821fac"
import script from "./examination-place.vue?vue&type=script&lang=js"
export * from "./examination-place.vue?vue&type=script&lang=js"

import "./examination-place.vue?vue&type=style&index=0&id=e0821fac&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__